if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        this.sanitizeSellingPlan(formData);

        this.addToCart(formData, false);
      }

      addToCart(formData, isRetry) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const body = new FormData();
        for (const [key, value] of formData.entries()) {
          if (key === 'sections' || key === 'sections_url') continue;
          body.append(key, value);
        }

        if (this.cart) {
          body.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          body.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = body;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              const sellingPlanError =
                (response.description && /selling plan/i.test(response.description)) ||
                (body.get('selling_plan') &&
                  response.message &&
                  /cart error/i.test(response.message));

              if (!isRetry && sellingPlanError) {
                formData.delete('selling_plan');
                formData.delete('properties[Discount]');
                return this.addToCart(formData, true);
              }

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: body.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || response.message);
              this.error = true;

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: body.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            this.error = true;
            this.handleErrorMessage(window.cartStrings?.error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      sanitizeSellingPlan(formData) {
        const scope = this.closest('.product-buy-buttons') || this.closest('.product') || document;
        if (scope.querySelector('[skio-plan-picker][skio-onetime-only]')) {
          formData.delete('selling_plan');
          formData.delete('properties[Discount]');
          return;
        }

        const sellingPlan = formData.get('selling_plan');
        if (!sellingPlan) return;

        const productJson = scope.querySelector('[skio-product-json]');
        if (!productJson) return;

        try {
          const product = JSON.parse(productJson.textContent);
          const variantId = parseInt(formData.get('id'), 10);
          const variant = product.variants.find((v) => v.id === variantId);
          const planId = parseInt(sellingPlan, 10);
          const isValid = variant?.selling_plan_allocations?.some(
            (allocation) => allocation.selling_plan_id === planId
          );
          if (!isValid) {
            formData.delete('selling_plan');
            formData.delete('properties[Discount]');
          }
        } catch (e) {
          console.error(e);
          formData.delete('selling_plan');
          formData.delete('properties[Discount]');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, preOrder = false) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else if (preOrder) {
          this.submitButton.removeAttribute('disabled');
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
